<template>
  <div class="wrapper">
    <div class="searchBar">
      <el-form
        :model="searchCondition"
        inline
        ref="searchForm"
        label-width="120px"
      >
        <el-form-item label="视频名称" prop="cataLogTitle">
          <el-input
            v-model="searchCondition.cataLogTitle"
            placeholder="视频名称"
            size="mini"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="视频状态" prop="status">
          <el-select v-model="searchCondition.status" size="mini">
            <el-option value="" label="全部"></el-option>
            <el-option :value="1" label="已上架"></el-option>
            <el-option :value="0" label="已下架"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="searchCondition.timeRange"
            size="mini"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="
              (e) => {
                [searchCondition.startTime, searchCondition.endTime] = e;
              }
            "
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData" size="mini"
            >查询</el-button
          >
          <el-button
            size="mini"
            @click="
              Object.assign(searchCondition, $options.data().searchCondition)
            "
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="tableBox">
      <!-- <div class="actBar">
        <div class="leftSide">
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="tableAct('role')"
            >导出</el-button
          >
        </div>
        <div class="rightSide"></div>
      </div> -->
      <div class="actBar">
        <el-button type="primary" @click="importData.ifShow = true"
          >批量导入</el-button
        >
      </div>
      <el-table
        :data="dataList"
        ref="table"
        border
        style="width: calc(100% - 40px); margin: 20px"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          fixed="left"
          width="55"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="courseTitle"
          label="视频(标题)名称"
          min-width="300"
        >
          <template slot-scope="scope">
            <div
              class="titleAndPoaster"
              style="display: flex; justify-content: space-around"
            >
              <el-image
                v-if="scope.row.avatar"
                style="width: 80px"
                :src="scope.row.avatar"
                fit="contain"
              ></el-image>
              <div style="width: 80px" v-else>无</div>
              <div class="title" style="flex: 1">
                {{ scope.row.courseTitle }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="cataLogTitle" label="所属课程" min-width="200">
        </el-table-column>
        <el-table-column prop="lecturerName" label="讲师" width="100">
        </el-table-column>
        <el-table-column prop="status" label="目录状态" width="100">
        </el-table-column
        ><el-table-column prop="sortOrder" label="排序" width="100">
        </el-table-column
        ><el-table-column prop="createTime" label="创建时间" width="160">
        </el-table-column
        ><el-table-column prop="learnPeople" label="学习人数" width="100">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          align="center"
          width="240"
          v-if="!ifComponent"
        >
          <template slot-scope="scope">
            <!-- <el-button type="text" size="small" @click="editStaff(scope.row)"
              >评论管理</el-button
            > -->
            <el-button type="text" size="small">删除</el-button>
            <el-button
              type="text"
              size="small"
              @click="tableAct('showLog', scope.row)"
              >学习记录</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="goTo('courseStudentManage', scope.row)"
              >学员管理</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="goTo('learnAnalysis', scope.row)"
              >数据分析</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="getData"
        :current-page.sync="searchCondition.pageNumber"
        :page-sizes="[10, 20, 50, 100]"
        :page-size.sync="searchCondition.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchCondition.total"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="用户编辑"
      :visible.sync="logData.ifShow"
      append-to-body
      top="2vh"
      width="50%"
    >
      <learn-log v-if="logData.ifShow" :item="logData.item"></learn-log>
    </el-dialog>
    <!-- <el-dialog
      :title="actData.title"
      :visible.sync="actData.ifShow"
      append-to-body
      width="50%"
    >
      <span slot="footer" class="dialog-footer">
        <el-button @click="actData.ifShow = false">取 消</el-button>
        <el-button type="primary" @click="actDialogSubmit">确 定</el-button>
      </span>
    </el-dialog> -->
    <el-dialog
      title="批量导入"
      :visible.sync="importData.ifShow"
      append-to-body
      width="80%"
    >
      <div>
        <el-button type="primary" @click="showCourseChoose">选择视频</el-button>
      </div>
      <div class="contentContainer">
        <div class="title">
          <div>已选择&emsp;{{ importData.courseList.length }}个</div>
          <div></div>
        </div>
        <div class="content">
          <el-tag
            v-for="tag in importData.courseList"
            :key="tag.id"
            @close="tagClose(tag)"
            style="margin: 10px"
            closable
            type=""
          >
            {{ tag.courseTitle }}
          </el-tag>
        </div>
      </div>
      <div class="actBar">
        <el-upload
          :on-change="uploadChange"
          action="/base/common/importLearningRecords"
          :data="{
            isExecute: 0,
            courseIds: importData.courseList.map((item) => item.id),
          }"
          :disabled="importData.courseList.length < 1"
          :file-list="importData.fileList"
          :headers="{ Authorization: getStore('accessToken') }"
          :on-success="importSuccess"
          :on-remove="
            () => {
              importData.fileList = [];
            }
          "
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        >
          <el-button size="mini" :disabled="importData.courseList.length < 1"
            >上传文件</el-button
          >
        </el-upload>
        <el-button
          type="text"
          size="small"
          @click="download('../批量课程导入模板.xlsx')"
        >
          下载模板</el-button
        >
      </div>
      <div class="contentContainer">
        <div class="title">可导入{{ importData.successNum }}课次</div>
        <div class="content">
          <el-table :data="importData.failList" border style="width: 100%">
            <el-table-column prop="userName" label="姓名"> </el-table-column>
            <el-table-column prop="mobile" label="电话"> </el-table-column>
            <el-table-column prop="positionName" label="职务">
            </el-table-column>
            <el-table-column prop="deptName" label="部门"> </el-table-column>
            <el-table-column prop="failMsg" label="原因"> </el-table-column>
          </el-table>
        </div>
      </div>
      <br />

      <el-button
        type="primary"
        @click="submitCourseImport"
        :disabled="importData.successNum < 1"
      >
        提交
      </el-button>
      <el-dialog
        title="选择课程"
        :visible.sync="importData.courseSelectIfShow"
        append-to-body
        width="70%"
      >
        <el-input
          v-model="importData.courseSearchConditon.courseTitle"
          style="width: 300px"
          size="mini"
        ></el-input>
        <el-button
          icon="el-icon-search"
          size="mini"
          @click="
            importData.courseSearchConditon.pageNumber = 1;
            getCourseList();
          "
          >搜索</el-button
        >
        <br />
        <el-table
          ref="multipleTable"
          :data="importCourseListForSelect"
          border
          style="width: 100%"
          @select="courseSelect"
          @select-all="courseSelectAll"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="courseTitle" label="课程名称" min-width="160">
          </el-table-column>
          <el-table-column label="封面" width="100">
            <template slot-scope="{ row }"
              ><el-image :src="row.courseImage" fit="contain">
                <div slot="error" class="image-slot">-</div></el-image
              ></template
            >
          </el-table-column>
          <!-- <el-table-column prop="courseImage" label="封面" width="120">
          </el-table-column> -->
          <el-table-column prop="" label="课程分类"> </el-table-column>
          <el-table-column prop="lecturerName" label="讲师名称" width="80">
          </el-table-column>
          <el-table-column prop="videoNum" label="视频数量" width="80">
          </el-table-column>
          <!-- <el-table-column prop="" label="操作" width="120"> </el-table-column> -->
        </el-table>
        <el-pagination
          small
          layout="prev, pager, next"
          :current-page.sync="importData.courseSearchConditon.pageNumber"
          :page-size.sync="importData.courseSearchConditon.pageSize"
          :total="importData.courseSearchConditon.total"
          @current-change="getCourseList"
        ></el-pagination>
        <div>
          <el-button size="small" @click="importData.courseSelectIfShow = false"
            >关闭</el-button
          >
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import { learnManageList, getCourseList, importCourseAndUser } from "@/api/bus";
import learnLog from "./component/learnLog.vue";
export default {
  props: {
    ifComponent: {
      type: Boolean,
      default: false,
    },
    catalogList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      importData: {
        ifShow: false,
        courseSelectIfShow: false,
        courseList: [],
        courseIds: [],
        courseListForSelect: [],
        searchKey: "",
        fileList: [],
        importFile: null,
        courseSearchConditon: {
          courseTitle: "",
          pageNumber: 1,
          pageSize: 10,
          total: 0,
        },
        fileList: [],
        failList: [],
        failNum: 0,
        successNum: 0,
      },
      searchCondition: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        status: "",
        cataLogTitle: "",
        courseTitle: "",
        startTime: "",
        endTime: "",
        timeRange: [],
      },
      selectList: [],
      dataList: [],
      logData: { ifShow: false, item: null },
      importCourseListForSelect: [],
    };
  },
  created() {},
  mounted() {
    this.getData();
    this.pageInit();
    console.log(this.$options.data().importData);
  },
  methods: {
    showCourseChoose() {
      this.importData.courseSelectIfShow = true;
      this.getCourseList();
    },
    getCourseList() {
      getCourseList(this.importData.courseSearchConditon).then((data) => {
        this.importCourseListForSelect = data.rows;
        this.importData.courseSearchConditon.total = data.total;
      });
    },
    courseSelectAll(selectList) {
      let courseIdsForSelect = this.importCourseListForSelect.map(
        (item) => item.id
      );
      if (selectList.length == 0) {
        this.importData.courseList = this.importData.courseList.filter(
          (item) => !courseIdsForSelect.includes(item.id)
        );
      } else {
        this.importData.courseList.push(
          ...this.importCourseListForSelect.filter(
            (item) =>
              !this.importData.courseList.find((course) => course.id == item.id)
          )
        );
      }
    },
    importSuccess(response, file, fileList) {
      this.importData.importFile = file;
      Object.assign(this.importData, response.data);
    },
    tagClose(tag) {
      this.importData.courseList.splice(
        this.importData.courseList.indexOf(tag),
        1
      );
    },
    submitCourseImport() {
      let postData = new FormData();
      postData.append("file", this.importData.fileList[0]);
      postData.append("isExecute", 1);
      postData.append(
        "courseIds",
        this.importData.courseList.map((item) => item.id)
      );

      importCourseAndUser(postData).then((data) => {
        this.getData();
        Object.assign(this.importData, this.$options.data().importData);
        this.$message.success("导入成功");
      });
    },
    courseSelect(selectList, select) {
      console.log(selectList, select);
      let findIndex = this.importData.courseList.findIndex(
        (item) => item.id == select.id
      );
      if (findIndex > -1) {
        this.importData.courseList.splice(findIndex, 1);
      } else {
        this.importData.courseList.push(select);
      }
    },
    uploadChange(e) {
      if (e.percentage == 100) {
        this.importData.fileList = [e.raw];
      }
    },
    goTo(url, item) {
      // console.log(typeof item.id);
      this.$router.push({ name: url, query: { id: item.id } });
    },
    download(url) {
      location.href = url;
    },
    tableAct(type, item) {
      switch (type) {
        case "showLog":
          this.logData = { ifShow: true, item };
          break;

        default:
          break;
      }
    },
    handleSelectionChange(e) {
      this.selectList = e;
    },
    getSelectList() {
      return this.selectList;
    },
    pageInit() {},
    getData() {
      let postData = {};
      for (let i in this.searchCondition) {
        if (this.searchCondition[i] !== "") {
          postData[i] = this.searchCondition[i];
        }
      }
      learnManageList(postData).then((data) => {
        this.dataList = data.rows;
        this.searchCondition.total = data.total;
        // 证书绑定课程用

        if (this.catalogList.length > 1) {
          let catalogIdList = this.catalogList.map((item) => item.id);

          setTimeout(() => {
            this.dataList.forEach((item) => {
              if (catalogIdList.includes(item.id)) {
                console.log(item.id + "勾了");
                this.$refs.table.toggleRowSelection(item, true);
              }
            });
          }, 200);
        }
      });
    },
  },
  components: { learnLog },
};
</script>

<style scoped lang="less">
.wrapper {
  //   display: flex;
  min-height: 600px;
  .searchBar {
    background: #fff;
    padding-top: 20px;
    margin-bottom: 20px;
  }

  .structureSide {
    flex: 1;
    min-width: 200px;
    margin-right: 10px;
    background: #fff;
  }
  .detailSide {
    flex: 5;
    background: #fff;
    padding: 20px;
  }
  .tableBox {
    background: #fff;
    .actBar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
    }
  }
}
.chosenBox {
  border: 1px solid #ccc;
  max-height: 200px;
  overflow: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  .chosenCell {
    padding: 0 10px;
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:last-child {
      border: none;
    }
    .detail {
      display: flex;
      height: 50px;
      align-items: center;
      .name {
        color: #999;
        margin-left: 10px;
      }
      .job {
        color: #ccc;
      }
    }
  }
}
</style>
